import * as angular from 'angular';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { EnumService } from '../../../app.common/modules/common/services/enum.service';
import { RetailerService } from '../api/retailer.service';
import { IRetailerRootScope } from '../core/models';

function uniqueEmail($rootScope: IRetailerRootScope, http: HttpService, enumService: EnumService, retailerService: RetailerService): ng.IDirective {

    return {
        require: 'ngModel',
        restrict: 'A',
        link: (scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {

            element.on('blur', async () => {
                if (!ctrl.$invalid || ctrl.$error.isunique) {
                    const isManager = $rootScope.userData.permission === $rootScope.enums.RetailerPermission.StoreManager;
                    try {
                        let isExist;
                        if (isManager) {
                            isExist = await http.get(retailerService.storeManagerAccountEmailExist(ctrl.$viewValue));
                        } else {
                            isExist = await http.post(retailerService.emailExist(ctrl.$viewValue), {});
                        }

                        ctrl.$setValidity('isunique', !<boolean>isExist);
                    } catch (error) {
                        console.warn('uniqueEmail error -', error);
                    }
                }
            });

        }
    };
}

uniqueEmail.$inject = ['$rootScope', 'http', 'enumService', 'retailerService'];
angular
    .module('app.common')
    .directive('uniqueEmail', uniqueEmail);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/uniqueEmail.directive.ts